/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowUpLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M7 17V7h10" }],
    ["path", { d: "M17 17 7 7" }]
  ]
];

export { ArrowUpLeft as default };
//# sourceMappingURL=arrow-up-left.js.map
